(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faucetera-cart-assurance"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit',function(event){var form=event.target;if(!form.matches('.cart-page'))return;var submitter=event.submitter;if(!submitter||submitter.name!=='checkout')return;var assurance=document.querySelector('[data-fp-cart-assurance]');if(!assurance)return;var checkbox=assurance.querySelector('[data-fp-cart-ack]');var error=assurance.querySelector('[data-fp-cart-error]');if(!checkbox||checkbox.checked)return;event.preventDefault();error.hidden=false;error.focus();checkbox.focus()});document.addEventListener('change',function(event){if(!event.target.matches('[data-fp-cart-ack]'))return;var assurance=event.target.closest('[data-fp-cart-assurance]');if(!assurance)return;var error=assurance.querySelector('[data-fp-cart-error]');if(error)error.hidden=true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faucetera-cart-policy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript && document.currentScript.closest('.shopify-section');
    const root = section ? section.querySelector('.fp-cart-policy') : document.querySelector('.fp-cart-policy');
    if (!root) return;

    const checkbox = root.querySelector('[data-fp-policy-checkbox]');
    const error = root.querySelector('[data-fp-policy-error]');
    const cartForms = Array.from(document.querySelectorAll('form[action*="/cart"]'));
    const checkoutButtons = () => Array.from(document.querySelectorAll('[name="checkout"]'));

    const setLockedState = () => {
      checkoutButtons().forEach((button) => {
        button.dataset.fpPolicyLocked = checkbox.checked ? 'false' : 'true';
        button.setAttribute('aria-disabled', checkbox.checked ? 'false' : 'true');
      });
      if (checkbox.checked) error.hidden = true;
    };

    const saveAcknowledgement = async () => {
      try {
        await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({attributes: {'Policy acknowledgement': checkbox.checked ? 'Accepted before checkout' : ''}})
        });
      } catch (requestError) {
        console.warn('Unable to save cart acknowledgement', requestError);
      }
    };

    checkbox.addEventListener('change', () => {
      setLockedState();
      saveAcknowledgement();
    });

    document.addEventListener('click', (event) => {
      const checkoutButton = event.target.closest('[name="checkout"]');
      if (checkoutButton && !checkbox.checked) {
        event.preventDefault();
        error.hidden = false;
        checkbox.focus();
      }
    }, true);

    cartForms.forEach((form) => {
      form.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        if (submitter && submitter.name === 'checkout' && !checkbox.checked) {
          event.preventDefault();
          error.hidden = false;
          checkbox.focus();
        }
      }, true);
    });

    setLockedState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faucetera-product-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const openButton = event.target.closest('[data-fp-dialog-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.getAttribute('data-fp-dialog-open'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }

    const closeButton = event.target.closest('[data-fp-dialog-close]');
    if (closeButton) {
      const dialog = closeButton.closest('dialog');
      if (dialog) dialog.close();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
